
import React, { useState } from "react";
import "../styles.css";
import "./credit-card.css";
import ReactModal from "react-modal";
import { BoxModal } from "../../../../components/boxModal";
import { FilterButton } from "../../../../components/E-check/style";
import { sendTransactionMfa } from "../../../../services/mfa.service";
import { toast } from "react-toastify";
import { getApiErrorMessage } from "../../../../utils/getApiErrorMessage";

export const ModalMfa = ({ handlePaymentConfirmation, data, setModalMfa, modalMfa, paymentLoader, setModalVoucher }) => {

  const [mfaCode, setMfaCode] = useState('');
  const [mfaSent, setMfaSent] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleSendMfa = async () => {
    try {
      await sendTransactionMfa();
      if (!mfaSent) {
        setMfaSent(true);
        toast.success('Código de confirmação enviado!');
      } else {
        toast.success('Novo código enviado!');
      }
      setIsDisabled(true);
      setCountdown(40);

      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            clearInterval(interval);
            setIsDisabled(false);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Não foi possível enviar o código. Tente novamente.'));
    }
  };

  const handlePayment = async () => {
    if (!mfaCode) {
      return toast.error('Insira o código de confirmação recebido por SMS.');
    }
    try {
      await handlePaymentConfirmation(mfaCode, data);
    } catch (error) {
      console.log(error);
      toast.error(getApiErrorMessage(error, 'Erro ao confirmar pagamento'));
    }
  }

  const handleClose = () => {
    setMfaCode('');
    setMfaSent(false);
    setIsDisabled(false);
    setCountdown(0);
    setModalMfa(false);
  };

  return (
    <ReactModal
      isOpen={modalMfa}
      className="change-modal"
      overlayClassName="overlay-pix-modal"
    >
      <BoxModal
        title="Confirmação de Pagamento"
        close={handleClose}
        maxWidth={400}
      >
        <div className="credit-card-container">
          {!mfaSent ? (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <p style={{ fontSize: '0.95rem', color: '#475569', marginBottom: '1.5rem' }}>
                Para confirmar o pagamento, enviaremos um código de verificação por SMS.
              </p>
              <FilterButton onClick={handleSendMfa}>
                Enviar Código de Confirmação
              </FilterButton>
            </div>
          ) : (
            <>
              <div
                className="card-form-section"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "1rem",
                }}
              >
                <div className="card-info-form" style={{ flex: 1, marginTop: "4px" }}>
                  <div className="container-row">
                    <input
                      id="name"
                      className="form-control"
                      name="cardholder"
                      maxLength="29"
                      type="text"
                      placeholder="Insira o código recebido por SMS"
                      value={mfaCode}
                      onChange={(e) => setMfaCode(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div style={{ marginTop: '0.75rem', fontSize: '0.85rem', color: '#666' }}>
                {isDisabled ? (
                  <p style={{ margin: 0 }}>
                    Você pode solicitar um novo código em 0:{countdown < 10 ? `0${countdown}` : countdown} segundos
                  </p>
                ) : (
                  <p style={{ margin: 0 }}>Não recebeu o código?</p>
                )}
                <button
                  onClick={handleSendMfa}
                  disabled={isDisabled}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: isDisabled ? '#999' : 'var(--primary-color, #3b82f6)',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    padding: '4px 0',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                    textDecoration: 'underline',
                  }}
                >
                  Reenviar Código
                </button>
              </div>

              <div className="row mt-4 align-items-center justify-content-start btn-area">
                <div className="col-md-3 button-area">
                  {paymentLoader ? (
                    <FilterButton disabled>
                      <span className="sr-only">Processando...</span>
                    </FilterButton>
                  ) : (
                    <FilterButton onClick={handlePayment}>
                      Confirmar Pagamento
                    </FilterButton>
                  )}

                  <button
                    type="button"
                    className="btn btn-secondary w-44 ml-2"
                    onClick={handleClose}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </BoxModal>
    </ReactModal>
  );
};
